// Take in a contact object and get the cell_phone, work_phone, or home_phone in that order
const getSMSFromContact = (contact) => {
  let phoneNumber;

  if (contact.customContact) {
    // return the label of the custom contact if set
    if (contact.label) {
      return contact.label;
    }
    return contact.name;
  }

  if (contact.cell_phone) {
    phoneNumber = contact.cell_phone;
  } else if (contact.work_phone) {
    phoneNumber = contact.work_phone;
  } else {
    phoneNumber = contact.home_phone;
  }

  // always remove plus sign from phonenumber when making sessionid
  if (phoneNumber && phoneNumber[0] === '+') {
    phoneNumber = phoneNumber.substring(1);
  }

  return phoneNumber;
};

export default getSMSFromContact;
